import { Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { ScenarioExt } from '@/classes/scenario/ScenarioExt';
import { ScenarioOpexExt } from '@/classes/scenario/ren-fr/opex/ScenarioOpexExt';

const getDefaultFields = () => new ScenarioOpexExt();

export const buildOpexModule = () => {

  @Module({
    namespaced: true
  })
  class OpexModule extends VuexModule {

    private presets: Record<string, string | number> | null = null;

    @Mutation
    private setPresets(payload: Record<string, string | number> | null) {
      this.presets = payload;
    }

    get getConfig(): ScenarioExt {
      return new ScenarioExt(this.context.rootGetters['scenario/getFields']);
    }

    get getFields(): ScenarioOpexExt {
      return this.getConfig.opex ? new ScenarioOpexExt(this.getConfig.opex) : getDefaultFields();
    }

    get getPresets(): Record<string, string | number> | null {
      return this.presets;
    }
  }

  return OpexModule;
};
